export default "__VITE_ASSET__D6GaQobv__"